import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessageField from 'components/field/MessageField/ErrorMessageField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const UserNotConfirmedNotification = (props) => {
    const {
        data,
        translate,
    } = props;

    if (utils.isEmpty(data)) {
        return null;
    }

    if (data.is_confirmed) {
        return null;
    }

    return (
        <ErrorMessageField>
            { translate(`resources.users.notifications.not_confirmed`) }
        </ErrorMessageField>
    );
};

UserNotConfirmedNotification.propTypes = {
    data: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(UserNotConfirmedNotification);



// WEBPACK FOOTER //
// ./src/components/notifications/UserNotConfirmedNotification.js